<template>
  <div>
    <b-form-input
      :id="context.id"
      v-model="coordinates"
      class="formulate-input-element"
      :state="touched ? isValid : null"
      style="background-color: transparent; color: #000000"
      placeholder="19.363159, -99.093328"
      @blur="touched = true"
    />

    <small v-if="touched && !isValid" class="text-danger">
      Ingresa coordenadas válidas. Ejemplo: 19.363159, -99.093328
    </small>

    <div v-if="isValid && coordinates" style="height: 200px; margin-top: 15px">
      <custom-map
        :key="coordinates"
        :lat="Number(coordinates.split(',')[0])"
        :lng="Number(coordinates.split(',')[1])"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from "@vue/composition-api";
import CustomMap from "@/views/components/GridView/layouts/slots/CustomMapSlot.vue";

export default {
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object,
  },
  components: {
    CustomMap,
  },

  setup(props) {
    const touched = ref(false);
    const isDisabled = ref(false);
    const coordinates = ref("");

    onMounted(() => {
      coordinates.value = props.context.model ?? "";
      isDisabled.value = props.context.attributes.disabled ?? false;
    });

    const isValid = computed(() => {
      if (!coordinates.value.trim()) return true;

      const match = coordinates.value
        .trim()
        .match(/^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/);

      if (!match) return false;

      const latitude = Number(match[1]);
      const longitude = Number(match[2]);

      return latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180;
    });

    watch(coordinates, (value) => {
      props.context.model = value;
    });

    watch(
      () => props.context.attributes.disabled,
      (value) => {
        isDisabled.value = value ?? false;
      },
      { immediate: true }
    );

    return {
      coordinates,
      touched,
      isValid,
      isDisabled,
    };
  },
};
</script>

